<template>
    <slide-up-modal
        v-if="modalDisplayed"
        ref="signFormModal"
        modal-id="signFormModal"
        modal-title="Signature électronique du contrat"
        @modal-closed="hideModal"
    >
        <p>
            <sign-form
            :contract-id="contract.id"
            :customer-id="contract.customer_id"
            @cancelled="hideModal"
            @loading="displayModalLoader"
            @loaded="hideModalLoader"
            @accepted="onAccepted"
            ></sign-form>
        </p>
    </slide-up-modal>
</template>

<script>
    import SlideUpModal from 'components/Modals/SlideUpModal'
    import SignForm from './SignForm'

    export default {
        data() {
            return {
                modalDisplayed: false
            }
        },

        props: ['contract'],

        components: {
            SlideUpModal,
            SignForm
        },

        methods: {
            displayModal() {
                this.modalDisplayed = true
            },

            hideModal() {
                this.modalDisplayed = false
            },

            displayModalLoader() {
                this.$refs.signFormModal.isLoading = true
            },

            hideModalLoader() {
                this.$refs.signFormModal.isLoading = false
            },

            onAccepted() {
                this.$emit('accepted')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/Contracts/DigitalSignature/SignModal.vue